import { render, staticRenderFns } from "./shezhi.vue?vue&type=template&id=283fd722&scoped=true&"
import script from "./shezhi.vue?vue&type=script&lang=ts&"
export * from "./shezhi.vue?vue&type=script&lang=ts&"
import style0 from "./shezhi.vue?vue&type=style&index=0&id=283fd722&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fd722",
  null
  
)

export default component.exports